import { ALL_SKILLS } from "./skills-Dj4T8Duc.js";
import { ParamSearchQuery } from "./schema-DKEjeVqP.js";
import { defineTool } from "./define-SD6AQa4b.js";
import { apiServiceFromContext } from "./api-EaEPyKlQ.js";
import { structuredResult } from "./results-NF1RJbDZ.js";
import { z } from "zod";

//#region src/tools/catalog/find-organizations.ts
const RESULT_LIMIT = 25;
const findOrganizationsOutputSchema = z.object({
	organizations: z.array(z.object({
		slug: z.string(),
		webUrl: z.string().url().nullable(),
		regionUrl: z.string().url().nullable()
	})),
	hasMore: z.boolean()
});
function normalizeUrl(url) {
	return url?.trim() ? url : null;
}
var find_organizations_default = defineTool({
	name: "find_organizations",
	skills: ALL_SKILLS,
	requiredScopes: ["org:read"],
	description: [
		"Find organizations that the user has access to in Sentry.",
		"",
		"Use this tool when you need to:",
		"- View organizations in Sentry",
		"- Find an organization's slug to aid other tool requests",
		"- Search for specific organizations by name or slug",
		"",
		`Returns up to ${RESULT_LIMIT} results. If you hit this limit, use the query parameter to narrow down results.`
	].join("\n"),
	inputSchema: { query: ParamSearchQuery.nullable().default(null) },
	annotations: {
		readOnlyHint: true,
		destructiveHint: false,
		openWorldHint: true
	},
	outputSchema: findOrganizationsOutputSchema,
	async handler(params, context) {
		const apiService = apiServiceFromContext(context);
		const organizations = await apiService.listOrganizations({
			query: params.query ?? void 0,
			limit: RESULT_LIMIT + 1
		});
		return structuredResult({
			organizations: organizations.slice(0, RESULT_LIMIT).map((organization) => ({
				slug: organization.slug,
				webUrl: normalizeUrl(organization.links?.organizationUrl),
				regionUrl: normalizeUrl(organization.links?.regionUrl)
			})),
			hasMore: organizations.length > RESULT_LIMIT
		});
	}
});

//#endregion
export { findOrganizationsOutputSchema, find_organizations_default };
//# sourceMappingURL=find-organizations-CXTZEMsb.js.map